import ReleaseNotes from './ReleaseNotes'
import withLayout from 'components/layout'

export default withLayout(ReleaseNotes)
